<template>
     <v-app>
        <v-btn  icon @click="backToDasboard()">
        <v-icon color="black">mdi-keyboard-backspace</v-icon>
        </v-btn>
        <v-container fill-height fluid>
            <v-row align="center" justify="center">
                
                <v-col cols="12" sm="12" md="4" lg="4">
                    <div class="text-center">
                        <h1>
                            Page Not Found
                        </h1>
                    </div>
                </v-col>
            </v-row>
            
        </v-container>
     </v-app>
</template>

<script>

export default {
    methods:{

        backToDasboard(){
            
            this.$router.push({ name: "dashboard" });
         }

    }
   
}


</script>